export default {
  state: {
    memoItem: null,
    memoDetail: null,
    passetDetail: null
  },
  mutations: {
    setMemoItem(state, payload) {
      state.memoItem = payload
    },
    setMemoDetail(state, payload) {
      state.memoDetail = payload
    },
    setPassetDetail(state, payload) {
      state.passetDetail = payload
    }
  },
  getters: {
    getMemoItem(state) {
      return state.memoItem
    },
    getMemoDetail(state) {
      return state.memoDetail
    },
    getPassetDetail(state) {
      return state.passetDetail
    }
  }
}
